import React, { useState, useEffect } from 'react';
import { loadEffect } from '../../img-effects/registry';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import useTranslation from '../../hooks/useTranslation';

/**
 * Componente genérico que carrega dinamicamente os controles de qualquer efeito
 */
const GenericEffectControls = ({ effectId, settings, onUpdate, onApply, onBack, onReset }) => {
  const { t } = useTranslation();
  const [EffectControls, setEffectControls] = useState(null);
  const [effectMetadata, setEffectMetadata] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadEffectControls = async () => {
      try {
        setIsLoading(true);
        const effect = await loadEffect(effectId);
        
        if (isMounted) {
          setEffectControls(() => effect.Controls);
          setEffectMetadata({
            name: effect.name,
            description: effect.description
          });
          setIsLoading(false);
        }
      } catch (error) {
        console.error(`Erro ao carregar controles do efeito ${effectId}:`, error);
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadEffectControls();

    return () => {
      isMounted = false;
    };
  }, [effectId]);

  if (isLoading) {
    return (
      <div className="flex flex-col h-full">
        <div className="p-3 border-b border-gray-200">
          <div className="flex items-center space-x-2">
            <button
              onClick={onBack}
              className="p-1 hover:bg-gray-100 rounded transition-colors"
              title="Voltar"
            >
              <ArrowLeftIcon className="w-5 h-5 text-gray-600" />
            </button>
            <h3 className="text-base font-semibold text-white">{t('common.loading')}</h3>
          </div>
        </div>
        <div className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <div className="w-8 h-8 border-4 border-green-200 border-t-green-600 rounded-full animate-spin mx-auto mb-2"></div>
            <p className="text-sm text-white">{t('effects.loadingEffect')}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!EffectControls) {
    return (
      <div className="flex flex-col h-full">
        <div className="p-3 border-b border-gray-200">
          <div className="flex items-center space-x-2">
            <button
              onClick={onBack}
              className="p-1 hover:bg-gray-100 rounded transition-colors"
              title="Voltar"
            >
              <ArrowLeftIcon className="w-5 h-5 text-gray-600" />
            </button>
            <h3 className="text-base font-semibold text-white">{t('common.error')}</h3>
          </div>
        </div>
        <div className="flex-1 flex items-center justify-center">
          <p className="text-sm text-white">{t('effects.effectNotFound')}</p>
        </div>
      </div>
    );
  }

  return (
    <EffectControls
      settings={settings}
      onUpdate={onUpdate}
      onApply={onApply}
      onBack={onBack}
    />
  );
};

export default GenericEffectControls;

